import React from 'react'

import { useLanguages } from '@/hooks'

export const Hero: React.FC = () => {
  const { t } = useLanguages()
  return (
    <div className="cover">
      <h1 className="blue-color">{t('carHireTitle')}</h1>
      <div></div>
    </div>
  )
}
